import {
  additionalOffsetTop,
  additionalHeight,
  adjustStickyPosition,
  horizontalScrollingElement,
} from "./modules/animation.js";

(function () {
  const anchors = document.querySelectorAll('.js-anchor[href^="#"]');
  let scrollTimeout = null;

  /**
   * Fonction pour gérer le clic sur les ancres
   *
   * @param {Event}       e      - L'événement de clic
   * @param {HTMLElement} target - L'élément cliqué (hyperlien)
   */
  const handleClick = (e, target) => {
    e.preventDefault();
    const targetId = target.getAttribute("href").substring(1);
    const targetElement = document.getElementById(targetId);
    // retournez getBoundingClientRect au lieu d'offsetTop à cause d'Elementor
    let targetElemOffsetTop = targetElement.getBoundingClientRect().top + window.scrollY;
    const hasFixedNav = !!document.querySelector(FIXEDNAV);
    targetElemOffsetTop += additionalOffsetTop(true, hasFixedNav ? ".js-fixedNav, .js-navbar" : NAVBAR);

    window.scrollTo({
      top: targetElemOffsetTop,
      behavior: "smooth",
    });

    if (scrollTimeout) {
      // Annuler le délai précédent si présent
      clearTimeout(scrollTimeout);
    }

    scrollTimeout = setTimeout(() => {
      updateAnchorStatus(target);
      horizontalScrollingElement(target, "smooth");
    }, 200);
  };

  const handleScroll = (target) => {
    // Mise à jour des classes des ancres
    const contentId = target.getAttribute("href").substring(1);
    const contentElement = document.getElementById(contentId);
    const contentRect = contentElement.getBoundingClientRect();

    const windowHeight = window.innerHeight;

    // Calculer le seuil de visibilité (par exemple, 50%)
    const visibilityThreshold = 0.25;

    if (
      contentRect.top < windowHeight * (1 - visibilityThreshold) &&
      contentRect.bottom > windowHeight * visibilityThreshold
    ) {
      updateAnchorStatus(target);
    }
  };

  const updateAnchorStatus = (el) => {
    anchors.forEach((anchor) => {
      anchor.classList.remove("is-active");
    });
    el.classList.add("is-active");
  };

  // pour chaque élément avec la classe js-anchor
  document.querySelectorAll('.js-anchor[href^="#"]').forEach((link) => {
    const handleLoad = () => {
      adjustStickyPosition();
      additionalHeight(false);
      handleScroll(link);
    };

    document.addEventListener("DOMContentLoaded", handleLoad);

    // Appelez la fonction nécessaire au clic sur les ancres
    link.addEventListener("click", (e) => {
      handleClick(e, link);
    });

    // Appelez la fonction nécessaire au scroll de la page
    window.addEventListener("scroll", () => {
      handleScroll(link);
    });
  });
})();
